import { render, staticRenderFns } from "./Create-Enquiry.vue?vue&type=template&id=31bfe145&scoped=true"
import script from "./Create-Enquiry.vue?vue&type=script&lang=js"
export * from "./Create-Enquiry.vue?vue&type=script&lang=js"
import style0 from "./Create-Enquiry.vue?vue&type=style&index=0&id=31bfe145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bfe145",
  null
  
)

export default component.exports